<template>
    <div class="page">
        <mt-header :title="title">
            <mt-button icon="back"   slot="left" @click="closeqShop">返回</mt-button> 
        </mt-header>        
        <div class="page-content">
            <Common-Query></Common-Query>
        </div>
    </div>
</template>
<script>
    import CommonQuery from "@/components/CommonQuery"
    import closeWebview from '@/components/closeWebview'
    export default {
        extends: closeWebview,
        data() {
            return {
  
            }
        },
        components: {
            CommonQuery
        },
        computed: {
            title: function() {
                console.log("this.iStorage", this.iStorage)
                const queryType = this.iStorage.get("queryType") || 'meal';
                if(queryType == 'meal') {
                    return "到餐查询"
                    return "餐厅查询"
                }
                if(queryType == 'venue') {
                    return "酒店查询"
                }
                if(queryType == "car") {
                    return "车队查询"
                }
                if(queryType == "iEvent") {
                    return "到餐查询"
                    return "美团商户查询"
                }   
                if(queryType == "iEventSYT") {
                    return "到餐查询"
                    return "商宴通商户查询"
                } 
            }
        },
        methods: {
            closeqShop() {
                this.closeWebview()
            },            
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/commonQueryIndex.vue